<template>
	<div class="full" style="background-color: white;">
		<div class="module_container full" style="position: relative;">
			<el-container class="full" style="position: relative;">
				<el-aside class="aside" width="200px">
					<knowledgetree ref="knowledgetree" :key="knowledgekey" @select="knowledgetreeChange" />
				</el-aside>
				<el-main class="main flex">
					<el-container class="full" style="position: relative;">
						<el-header height="auto" class="head">
							<el-input placeholder="请输入内容" v-model="keyword" class="input-with-select">
								<el-button slot="append" icon="el-icon-search"></el-button>
							</el-input>
						</el-header>
						<el-main class="main flex" style="flex-direction: row;flex-wrap: wrap;overflow: auto;">
							<div class="box" v-for="(item,index) in segments" :key="index"
								@mouseover="cardeditShow(item)" @mouseleave="cardeditHide(item)">
								<div class="card full flex">
									<div class="question">{{item.content}}</div>
									<div class="content">{{item.answer}}</div>
									<div class="keyword">
										<el-tag v-for="item in item.customekeywords" :key="item" effect="dark"
											size="small" style="margin: 2px;">
											{{item}}
										</el-tag>
										<el-tag v-for="item in item.difykeywords" :key="item" effect="dark" size="small"
											style="margin: 2px;" type="info">
											{{item}}
										</el-tag>
									</div>
									<div class="controll flex">
										<el-button type="text" style="margin: 0px;" size="mini"
											@click="edit(item)">编辑</el-button>
										<el-button type="text" style="margin-left: 10px;color: #F56C6C;" size="mini"
											@click="del(item)">删除</el-button>
									</div>
								</div>
							</div>
						</el-main>
					</el-container>
				</el-main>
			</el-container>
		</div>
		<edit :id="id" v-if="editShow" :segment="currentsegment" @back="editBack" />
	</div>
</template>
<style scoped>
	.box {
		width: 25%;
		position: relative;
		display: inline-block;
		box-sizing: border-box;
		padding: 10px;
		height: 300px;
		overflow: hidden;
		word-break: break-all;

	}

	.card {
		flex-direction: column;
		position: relative;
		box-shadow: 0px 0px 2px black;
		box-sizing: border-box;
		padding: 10px;
		border-radius: 10px;
		overflow: hidden;
	}

	.card_edit {
		align-items: center;
		justify-content: center;

	}

	.question {
		font-weight: bolder;
		font-size: 18px;
	}

	.content {
		flex: 1;
		overflow: auto;
		margin: 10px 0;
	}

	.controll {
		margin-top: 5px;
		justify-content: flex-end;
	}

	.module_container {
		box-sizing: border-box;
		padding-bottom: 10px;
	}

	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}

	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}

	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;

	}

	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	import knowledgetree from './knowledgetree/tree.vue'
	import edit from './edit/form.vue'
	export default {
		name: 'knowledgeIndex',
		props: {

		},

		data() {
			return {
				moduleName: 'knowledge',
				windowName: '知识库',
				windowType: 'modal',
				knowledgekey: Math.random(),
				keyword: '1008030036',
				segments: [],
				currentdatasetid:null,
				currentdocumentid:null,
				currentsegment: null,
				id: 0,
				editShow: false,
			}
		},
		watch: {

		},
		created() {
			//this.initList()
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			initList() {
				// this.$api.knowledge.list().then((res) => {
				// 	this.segments = res
				// })
			},
			list(){
				this.$api.knowledge.getSegments({
					datasetid: this.currentdatasetid,
					documentid: this.currentdocumentid,
				}).then((res) => {
					res.forEach((item) => {
						item.editShow = false
					})
					this.segments = res
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			knowledgetreeChange(e) {
				console.log(e.datasource)
				if (e.type == 'document') {
					this.currentdatasetid = e.datasource.datasetid
					this.currentdocumentid = e.datasource.id
					this.list()
				}
				//console.log(e)
			},
			cardeditShow(item) {
				item.editShow = true
			},
			cardeditHide(item) {
				item.editShow = false
			},
			edit(e) {
				//console.log(e)
				this.currentsegment = e
				this.id = e.knowledgeid
				this.editShow = true
			},
			editBack() {
				this.editShow = false
			},
			del(e) {
				this.$confirm('是否确认删除').then(() => {
					this.loading = true
					this.$api.knowledge.delete(0, {
						segmentid: e.id,
						datasetid: this.currentdatasetid,
						documentid: this.currentdocumentid,
					}).then(() => {
						this.list()
						this.$message.success('操作成功')
						this.loading = false
					}, () => {
						this.loading = false
					})
				})
			}
		},
		components: {
			knowledgetree,
			edit
		}
	}
</script>